import { c as _c } from "react/compiler-runtime";
import { BackupPolicyType, ResourceType } from '@repo/api-gw-sdk';
import { useMemo } from 'react';
import { useFeatureFlags } from '@/contexts/useFeatureFlags';
import { useSupportedResourceTypes } from '@/data/inventory/useSupportedResourceTypes';
export const useBackupPolicyAvailableTypes = () => {
  const $ = _c(53);
  const {
    EC2HighFrequencyBackupEnabled,
    GcpVmHighFrequencyBackupEnabled,
    RdsHighFrequencyBackupEnabled,
    SapHanaPitrSupport,
    AzureSqlVirtualMachineSupport,
    EnableBigQueryNativePolicy,
    AwsRedshiftNativeBackupSupport,
    AwsKeyspacesSupport,
    AwsDocumentDbSupport,
    NeptuneBackupSupport,
    MongoAtlasSupport,
    AzureFilesSupport
  } = useFeatureFlags();
  const allTypes = useSupportedResourceTypes();
  let t0;
  if ($[0] !== EC2HighFrequencyBackupEnabled) {
    t0 = EC2HighFrequencyBackupEnabled ? [ResourceType.AwsEc2] : [];
    $[0] = EC2HighFrequencyBackupEnabled;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== GcpVmHighFrequencyBackupEnabled) {
    t1 = GcpVmHighFrequencyBackupEnabled ? [ResourceType.GcpComputeEngineInstance] : [];
    $[2] = GcpVmHighFrequencyBackupEnabled;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== RdsHighFrequencyBackupEnabled) {
    t2 = RdsHighFrequencyBackupEnabled ? [ResourceType.AwsRds] : [];
    $[4] = RdsHighFrequencyBackupEnabled;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== AwsKeyspacesSupport) {
    t3 = AwsKeyspacesSupport ? [ResourceType.AwsKeyspacesTable] : [];
    $[6] = AwsKeyspacesSupport;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== MongoAtlasSupport) {
    t4 = MongoAtlasSupport ? [ResourceType.AtlasMongodbCluster] : [];
    $[8] = MongoAtlasSupport;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t0 || $[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4) {
    t5 = [...t0, ...t1, ...t2, ResourceType.AwsDynamoDb, ...t3, ResourceType.AwsS3, ResourceType.GcpCloudStorageBucket, ...t4];
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  const HighFrequencySupportedResourceTypes = t5;
  let t6;
  if ($[16] !== AzureSqlVirtualMachineSupport) {
    t6 = AzureSqlVirtualMachineSupport ? [ResourceType.AzureSqlVirtualMachine] : [];
    $[16] = AzureSqlVirtualMachineSupport;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== SapHanaPitrSupport) {
    t7 = SapHanaPitrSupport ? [ResourceType.AzureSapHanaVm, ResourceType.GcpSapHanaVm] : [];
    $[18] = SapHanaPitrSupport;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== t6 || $[21] !== t7) {
    t8 = [...t6, ...t7];
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const pitrPolicySupportedResourceTypes = t8;
  let t9;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = [ResourceType.AwsRds];
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const nativePitrPolicySupportedResourceTypes = t9;
  let t10;
  if ($[24] !== EnableBigQueryNativePolicy) {
    t10 = [...(EnableBigQueryNativePolicy ? [ResourceType.GcpBigQuery] : [])];
    $[24] = EnableBigQueryNativePolicy;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  const bigQueryNativePitrSupportedResourceTypes = t10;
  let t11;
  if ($[26] !== AwsRedshiftNativeBackupSupport) {
    t11 = AwsRedshiftNativeBackupSupport ? [ResourceType.AwsRedshift] : [];
    $[26] = AwsRedshiftNativeBackupSupport;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== AwsDocumentDbSupport) {
    t12 = AwsDocumentDbSupport ? [ResourceType.AwsDocumentdb] : [];
    $[28] = AwsDocumentDbSupport;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== NeptuneBackupSupport) {
    t13 = NeptuneBackupSupport ? [ResourceType.AwsNeptune] : [];
    $[30] = NeptuneBackupSupport;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  let t14;
  if ($[32] !== t11 || $[33] !== t12 || $[34] !== t13) {
    t14 = [ResourceType.AwsFsx, ResourceType.AwsEfs, ...t11, ...t12, ...t13];
    $[32] = t11;
    $[33] = t12;
    $[34] = t13;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  const awsNativeStandardPolicySupportedResourceTypes = t14;
  let t15;
  if ($[36] !== AzureFilesSupport) {
    t15 = [...(AzureFilesSupport ? [ResourceType.AzureFileShare] : [])];
    $[36] = AzureFilesSupport;
    $[37] = t15;
  } else {
    t15 = $[37];
  }
  const azureFilesPolicySupportedResourceTypes = t15;
  let t16;
  if ($[38] !== allTypes || $[39] !== awsNativeStandardPolicySupportedResourceTypes || $[40] !== azureFilesPolicySupportedResourceTypes) {
    let t17;
    if ($[42] !== awsNativeStandardPolicySupportedResourceTypes || $[43] !== azureFilesPolicySupportedResourceTypes) {
      t17 = type => !awsNativeStandardPolicySupportedResourceTypes.includes(type) && !azureFilesPolicySupportedResourceTypes.includes(type);
      $[42] = awsNativeStandardPolicySupportedResourceTypes;
      $[43] = azureFilesPolicySupportedResourceTypes;
      $[44] = t17;
    } else {
      t17 = $[44];
    }
    t16 = [...allTypes.filter(t17)];
    $[38] = allTypes;
    $[39] = awsNativeStandardPolicySupportedResourceTypes;
    $[40] = azureFilesPolicySupportedResourceTypes;
    $[41] = t16;
  } else {
    t16 = $[41];
  }
  const standardPolicySupportedResourceTypes = t16;
  let t17;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = [];
    $[45] = t17;
  } else {
    t17 = $[45];
  }
  let t18;
  if ($[46] !== HighFrequencySupportedResourceTypes || $[47] !== awsNativeStandardPolicySupportedResourceTypes || $[48] !== azureFilesPolicySupportedResourceTypes || $[49] !== bigQueryNativePitrSupportedResourceTypes || $[50] !== pitrPolicySupportedResourceTypes || $[51] !== standardPolicySupportedResourceTypes) {
    t18 = {
      [BackupPolicyType.BACKUP_POLICY_TYPE_HIGH_FREQUENCY]: HighFrequencySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_PITR]: pitrPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_PITR]: nativePitrPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_STANDARD]: standardPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AWS_NATIVE_STANDARD]: awsNativeStandardPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_BIGQUERY_NATIVE_PITR]: bigQueryNativePitrSupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_AZURE_FILES]: azureFilesPolicySupportedResourceTypes,
      [BackupPolicyType.BACKUP_POLICY_TYPE_UNSPECIFIED]: t17
    };
    $[46] = HighFrequencySupportedResourceTypes;
    $[47] = awsNativeStandardPolicySupportedResourceTypes;
    $[48] = azureFilesPolicySupportedResourceTypes;
    $[49] = bigQueryNativePitrSupportedResourceTypes;
    $[50] = pitrPolicySupportedResourceTypes;
    $[51] = standardPolicySupportedResourceTypes;
    $[52] = t18;
  } else {
    t18 = $[52];
  }
  const policySupportedResourceTypes = t18;
  return policySupportedResourceTypes;
};